import md5 from 'md5'

export const getHashFromDate = (): string => md5(new Date().toISOString())

export default {
  getHashFromDate,
}
